// 依存を増やさないためのインラインSVGアイコン（stroke ベース, currentColor）。

type IconProps = { name: string; className?: string };

const PATHS: Record<string, React.ReactNode> = {
  chevron: <path d="M9 6l6 6-6 6" />,
  bell: (
    <>
      <path d="M6 9a6 6 0 0 1 12 0c0 6 2 7 2 7H4s2-1 2-7" />
      <path d="M10.5 20a1.8 1.8 0 0 0 3 0" />
    </>
  ),
  help: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.2 9.3a2.8 2.8 0 0 1 5.4 1c0 1.8-2.6 2.2-2.6 3.7M12 17.2v.05" />
    </>
  ),
  chat: <path d="M4 5h16v11H9l-4 3v-3H4z" />,
  grid: (
    <>
      <path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z" />
    </>
  ),
  home: <path d="M3 10.5 12 3l9 7.5M5 9.5V21h14V9.5" />,
  deals: (
    <>
      <path d="M3 7h18M3 12h18M3 17h18" />
      <circle cx="7.5" cy="7" r="0.1" />
    </>
  ),
  journal: (
    <>
      <path d="M5 3h11l3 3v15H5z" />
      <path d="M8 8h8M8 12h8M8 16h5" />
    </>
  ),
  voucher: (
    <>
      <path d="M4 4h16v16H4z" />
      <path d="M12 4v16M4 12h16" />
    </>
  ),
  wallet: (
    <>
      <path d="M3 7h15a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <path d="M3 7V5.5A1.5 1.5 0 0 1 4.5 4H16M16 13h2" />
    </>
  ),
  sync: <path d="M4 9a8 8 0 0 1 13-3l3 3M20 15a8 8 0 0 1-13 3l-3-3M17 3v6h-6M7 21v-6h6" />,
  ledger: (
    <>
      <path d="M4 4h16v16H4z" />
      <path d="M4 9h16M9 9v11" />
      <path d="M12 13h5M12 16h5" />
    </>
  ),
  asset: (
    <>
      <path d="M3 21h18M5 21V10l7-5 7 5v11" />
      <path d="M9 21v-6h6v6" />
    </>
  ),
  report: (
    <>
      <path d="M4 20V4M4 20h16" />
      <path d="M8 16v-4M12 16V8M16 16v-6" />
    </>
  ),
  accounts: (
    <>
      <path d="M4 5h16v14H4z" />
      <path d="M4 10h16M10 5v14" />
    </>
  ),
  partner: (
    <>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20a6 6 0 0 1 12 0M16 5a3 3 0 0 1 0 6M21 20a6 6 0 0 0-5-5.9" />
    </>
  ),
  invoice: (
    <>
      <path d="M6 3h9l3 3v15l-2.5-1.5L13 21l-2.5-1.5L8 21l-2-1.5L4 21V6z" />
      <path d="M8 8h7M8 12h7M8 16h4" />
    </>
  ),
  quote: (
    <>
      <path d="M5 3h9l5 5v13H5z" />
      <path d="M14 3v5h5M9 13h6M9 17h4" />
    </>
  ),
  expense: (
    <>
      <path d="M4 5h16v14H4z" />
      <path d="M12 8v8M9.5 10a2 2 0 0 1 2-1.5c1.2 0 2 .7 2 1.6 0 2-3.8 1.4-3.8 3.3 0 .9.8 1.6 2 1.6a2 2 0 0 0 2-1.5" />
    </>
  ),
  closing: (
    <>
      <path d="M12 3a9 9 0 1 0 9 9" />
      <path d="M12 7v5l3 2M21 4v4h-4" />
    </>
  ),
  settings: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" />
    </>
  ),
};

export function Icon({ name, className }: IconProps) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {PATHS[name] ?? PATHS.home}
    </svg>
  );
}
